import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import { EmployeeDetailsEstateReport } from './Pages';

export const EmployeeDetailsEstateReportRoutes = ({ match }) => (

    <Fragment>
        <Route exact path = {`${match.path}`} component={EmployeeDetailsEstateReport} />
    </Fragment>

)